import script from "./goRinSyo0046.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0046.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0046.vue?vue&type=style&index=0&id=1345d3ba&lang=scss"

const __exports__ = script;

export default __exports__